import { render, staticRenderFns } from "./UniversalDataTable.vue?vue&type=template&id=1b6f0170&"
import script from "./UniversalDataTable.vue?vue&type=script&lang=js&"
export * from "./UniversalDataTable.vue?vue&type=script&lang=js&"
import style0 from "./UniversalDataTable.vue?vue&type=style&index=0&id=1b6f0170&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VDataTable,VIcon,VPagination,VProgressLinear,VRow,VSelect})
